"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _context = require("../Sidebar/context");

var _RenderIf = _interopRequireDefault(require("../RenderIf"));

var _InternalTooltip = _interopRequireDefault(require("../InternalTooltip"));

var _useDefaultTooltipConnector = _interopRequireDefault(require("../InternalTooltip/hooks/useDefaultTooltipConnector"));

var _li = _interopRequireDefault(require("./styled/li"));

var _anchorContent = _interopRequireDefault(require("./styled/anchorContent"));

var _buttonContent = _interopRequireDefault(require("./styled/buttonContent"));

var _itemContent = _interopRequireDefault(require("./itemContent"));

/* eslint-disable no-script-url, react/prop-types */

/**
 * @category Layout
 */
function SidebarItem(props) {
  var label = props.label,
      icon = props.icon,
      selectedIcon = props.selectedIcon,
      name = props.name,
      href = props.href,
      onClick = props.onClick,
      className = props.className,
      style = props.style,
      selectedItem = props.selectedItem,
      onSelect = props.onSelect,
      tooltip = props.tooltip,
      hideSelectedItemIndicator = props.hideSelectedItemIndicator;

  var _triggerRef = (0, _react.useRef)();

  var tooltipRef = (0, _react.useRef)();
  var isSelected = name === selectedItem;
  var currentIcon = isSelected && !!selectedIcon ? selectedIcon : icon;

  var _useDefaultTooltipCon = (0, _useDefaultTooltipConnector["default"])({
    tooltipRef: tooltipRef,
    triggerRef: function triggerRef() {
      return _triggerRef;
    }
  }),
      onMouseEnter = _useDefaultTooltipCon.onMouseEnter,
      onMouseLeave = _useDefaultTooltipCon.onMouseLeave,
      isVisible = _useDefaultTooltipCon.isVisible;

  var getAriaCurrent = function getAriaCurrent() {
    if (isSelected) {
      return 'page';
    }

    return undefined;
  };

  function handleOnClick(event) {
    onClick(event);
    onSelect(event, name);
  }

  return /*#__PURE__*/_react["default"].createElement(_li["default"], {
    "data-id": "sidebar-item-li",
    isSelected: isSelected,
    className: className,
    style: style,
    hideSelectedItemIndicator: hideSelectedItemIndicator
  }, /*#__PURE__*/_react["default"].createElement(_RenderIf["default"], {
    isTrue: href
  }, /*#__PURE__*/_react["default"].createElement(_anchorContent["default"], {
    "data-id": "sidebar-item-clickable-element",
    href: href,
    onClick: handleOnClick,
    "aria-current": getAriaCurrent(),
    isSelected: isSelected,
    ref: _triggerRef,
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave
  }, /*#__PURE__*/_react["default"].createElement(_itemContent["default"], {
    isSelected: isSelected,
    label: label,
    icon: currentIcon
  }))), /*#__PURE__*/_react["default"].createElement(_RenderIf["default"], {
    isTrue: !href
  }, /*#__PURE__*/_react["default"].createElement(_buttonContent["default"], {
    "data-id": "sidebar-item-clickable-element",
    onClick: handleOnClick,
    "aria-current": getAriaCurrent(),
    isSelected: isSelected,
    ref: _triggerRef,
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave
  }, /*#__PURE__*/_react["default"].createElement(_itemContent["default"], {
    isSelected: isSelected,
    label: label,
    icon: currentIcon
  }))), /*#__PURE__*/_react["default"].createElement(_RenderIf["default"], {
    isTrue: tooltip
  }, /*#__PURE__*/_react["default"].createElement(_InternalTooltip["default"], {
    triggerElementRef: function triggerElementRef() {
      return _triggerRef;
    },
    isVisible: isVisible,
    preferredPosition: "right",
    ref: tooltipRef
  }, tooltip)));
}

SidebarItem.propTypes = {
  /** A unique identifier for the navigation item. */
  name: _propTypes["default"].string,

  /** The text to show if it is passed. The text displayed for the SidebarItem. */
  label: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),

  /** The icon displayed for the SidebarItem. It must be a svg icon or a font icon. */
  icon: _propTypes["default"].node,

  /** The icon displayed for the SidebarItem when it is selected. It must be a svg icon or a font icon.
   * By default it takes the value of icon prop
   */
  selectedIcon: _propTypes["default"].node,

  /** The URL of the page that the navigation item goes to. */
  href: _propTypes["default"].string,

  /** Event fired when the item is clicked. */
  onClick: _propTypes["default"].func,

  /** A CSS class for the outer element, in addition to the component's base classes. */
  className: _propTypes["default"].string,

  /** An object with custom style applied for the outer element. */
  style: _propTypes["default"].object,

  /** A tooltip to show on hover */
  tooltip: _propTypes["default"].node
};
SidebarItem.defaultProps = {
  name: undefined,
  label: undefined,
  icon: null,
  selectedIcon: null,
  href: undefined,
  onClick: function onClick() {},
  className: undefined,
  style: undefined,
  tooltip: undefined
};

var _default = (0, _context.withContext)(SidebarItem);

exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-rainbow-components/components/SidebarItem/index.js
// module id = KO2S
// module chunks = 0